import { ViewChild, Component, HostListener, EventEmitter, Output } from '@angular/core';
import {
    ViewController,
    NavParams } from 'ionic-angular';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Arena } from '../../../../model/arena';
import { RodeoService } from '../../../../services/rodeo.service';
import { AlertMessager } from '../../../../lib/alertMessager';

@Component({
    selector: 'search-box',
    templateUrl: 'search-box.component.html'
})
export class SearchBoxComponent {
    @Output() arenaSelected = new EventEmitter();
    @ViewChild('searchBox') searchBox;  

    searchChangeObservable;
    selecting: boolean = false;
    
    results: any = [];
    searchValue: string = '';
    selectedArena: Arena;

    loadingData: boolean = true;
    
    constructor(
                private _viewCtrl: ViewController,
                private rodeoService: RodeoService,
                private alert: AlertMessager) {
    }

    public onSearchChange(searchEvent, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForArena(searchValue) });
        }

        this.searchChangeObservable.next(searchValue);
    }

	searchForArena(searchValue : string) {
        this.loadingData = true;

        this.rodeoService.searchForArena(searchValue)
        .then(data => {
            this.loadingData = false;
            this.results = data;

            if (this.results.length > 0) {
                this.selectedArena = this.results[0];
            } else {
                this.selectedArena = null;
            }
        })
        .catch(error => {
            this.alert.showError('Error', 'Unable to retrieve search results: ' + error);
            this.loadingData = false;
        });
	}

    selectItem(item) {
        this.arenaSelected.next(item);
    }

    addNewArena() {
        this.arenaSelected.next({ name: this.searchValue });
    }

    getSearchMessage() {
        if (this.searchValue == undefined || this.searchValue.trim().length == 0)
            return "";
        else if (this.results == undefined || this.results.length < 1)
            return "There are no arenas by that name.";

        return "";
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 38 && this.results.length > 0) {
            if (this.results[0] !== this.selectedArena) {
                let index = this.results.indexOf(this.selectedArena);

                this.selectedArena = this.results[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.results.length > 0) {
            if (this.results[this.results.length - 1] !== this.selectedArena) {
                let index = this.results.indexOf(this.selectedArena);

                this.selectedArena = this.results[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedArena != null) {
            this.selectItem(this.selectedArena);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/search-box.component.ts